import React, { useState } from "react";
import SimpleDialog from "../00_common/SimpleDialog";
import "./20_SignUp.css";

function SignUp({ setShowSignDialog }) {
  const [showDialogSignUpComplete, setShowDialogSignUpComplete] =
    useState(false);

  function signUp() {
    // TODO 회원가입 처리
    setShowDialogSignUpComplete(true);
  }

  function cancelSignUp() {
    setShowSignDialog(false);
  }

  function signUpComplet() {
    setShowSignDialog(false);
    setShowDialogSignUpComplete(false);
  }
  return (
    <>
      <div className="modal sign">
        <div className="container">
          <div className="cp-account">
            <div className="account-form">
              <form onSubmit={signUp}>
                <div className="top-bar">
                  <i className="fa-solid fa-user-pen" />
                  <button
                    className="btn-close"
                    type="button"
                    onClick={() => cancelSignUp()}
                  >
                    <i className="fa-solid fa-xmark" />
                  </button>
                </div>
                <div className="content">
                  <div className="input-wrap">
                    <label htmlFor="name">Your Name</label>
                    <input
                      type="text"
                      id="name"
                      placeholder="Name"
                      list="input-name"
                    />
                    <datalist id="input-name">
                      <option value="Nguyên Phuong" />
                    </datalist>
                  </div>
                  <div className="input-wrap">
                    <label htmlFor="email">Email address</label>
                    <input
                      type="email"
                      id="email"
                      placeholder="Email"
                      list="input-email"
                    />
                    <datalist id="input-email">
                      <option value="nguyen@customer.com" />
                    </datalist>
                  </div>
                  <div className="select-wrap">
                    <label htmlFor="country">Country</label>
                    <select
                      className="filter-type"
                      id="country"
                      defaultValue="1"
                    >
                      <option value="" disabled>
                        Country
                      </option>
                      <option value={1}>Vietnam</option>
                      <option value={2}>Singapore</option>
                    </select>
                  </div>
                  <div className="input-wrap contact">
                    <label htmlFor="phone">Contact</label>
                    <div className="wrap">
                      <div className="icon-wrap">
                        <i className="fa-solid fa-phone" />
                      </div>
                      <input
                        type="tel"
                        id="phone"
                        placeholder="Number only"
                        list="input-phone"
                      />
                      <datalist id="input-phone">
                        <option value="033-123-4567" />
                      </datalist>
                    </div>
                  </div>
                  <div className="input-wrap">
                    <label htmlFor="password">Password</label>
                    <input
                      type="password"
                      id="password"
                      placeholder="Password"
                    />
                  </div>
                  <div className="input-wrap">
                    <label htmlFor="confirmPassword">Confirm Password</label>
                    <input
                      type="password"
                      id="confirmPassword"
                      placeholder="Confirm Password"
                    />
                  </div>
                </div>
                <div className="btn-wrap">
                  Your data will be <span>handled with care</span>
                  <button
                    className="btn round type-manager btn-l"
                    type="button"
                    onClick={() => signUp()}
                  >
                    Sign Up
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showDialogSignUpComplete && (
        <SimpleDialog
          type="alert"
          message="Customer information has been registered."
          yesButtonName="OK"
          yesButtonOnClick={signUpComplet}
          yesButtonClass="type-manager"
        />
      )}
    </>
  );
}

export default SignUp;
